export function initGlossar() {
    for (const wrapper of document.querySelectorAll('.glossar')) {
        const tabs = wrapper.querySelectorAll('.glossar__tab');
        const panels = wrapper.querySelectorAll('.glossar__panel');

        if (!tabs.length || !panels.length) continue;

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const count = tab.dataset.count;

                tabs.forEach(t => t.classList.toggle('glossar__tab--active', t === tab));
                panels.forEach(p => p.classList.toggle('glossar__panel--active', p.dataset.count === count));

                tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            });
        });
    }
}
